import React from 'react';
import MainContainer from '../../container/MainContainer';
import EditProfileBanner from './EditProfileBanner';
import EditProfileHeader from './EditProfileHeader';
import EditCouncilProfile from './EditCouncilProfile';
import { VIEW_PROFILE } from '../../query/ViewProfile';
import { EDIT_COUNCIL_PROFILE } from '../../mutation/EditCouncilProfile';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { hasuraClient } from '../../apolloClient';

const EditProfileLayout = (props) => {
	const [CouncilProfile] = useMutation(EDIT_COUNCIL_PROFILE, {
		client: hasuraClient,
	});
	const { data: profile_data, refetch: profile_refetch } = useQuery(
		VIEW_PROFILE,
		{
			client: hasuraClient,
		}
	);

	return (
		<MainContainer className="edit-profile-main">
			<section className='council-cover'>
				<EditProfileBanner
					data={profile_data}
					CouncilProfile={CouncilProfile}
					refetch={profile_refetch}
				/>
				<div className='council-row edit-council'>
					<EditProfileHeader
						data={profile_data}
						CouncilProfile={CouncilProfile}
						refetch={profile_refetch}
					/>
					<EditCouncilProfile
						data={profile_data}
						CouncilProfile={CouncilProfile}
					/>
				</div>
			</section>
		</MainContainer>
	);
};

export default EditProfileLayout;
